import React from "react";
import KuikaStatusGlyph, { KuikaStatusGlyphVariant } from "../../ui-kit/kuika-status-glyph/kuika-status-glyph";
import { StatusCategory, STATUS_DOT_COLOR } from "./types";

/**
 * The board's mapping onto the shared `KuikaStatusGlyph`: this file owns the board's status
 * vocabulary and colour map, the primitive owns the shapes. The Helpdesk board maps its own
 * open/pending/solved the same way — neither vocabulary leaks into the ui-kit.
 */
export interface StatusGlyphProps {
  category: StatusCategory;
  size?: number;
  className?: string;
}

const VARIANT_BY_CATEGORY: Record<StatusCategory, KuikaStatusGlyphVariant> = {
  todo: "not-started",
  in_progress: "in-progress",
  done: "done"
};

const LABEL_BY_CATEGORY: Record<StatusCategory, string> = {
  todo: "Not started",
  in_progress: "In progress",
  done: "Done"
};

const StatusGlyph: React.FC<StatusGlyphProps> = ({ category, size, className }) => (
  <KuikaStatusGlyph
    variant={VARIANT_BY_CATEGORY[category]}
    color={STATUS_DOT_COLOR[category]}
    label={LABEL_BY_CATEGORY[category]}
    size={size}
    className={className}
  />
);

export default StatusGlyph;
